import React from 'react'
import { injectIntl } from 'react-intl'
import { defaultMessages } from '../../../../libs/i18n/default'
import Logout from '../../../../shared/components/Logout'
import Pages from '../../pages'

class Header extends React.Component {
  render() {
    const logo = () => {
      if (this.props.logoUrl){
        return(<img src={this.props.logoUrl} />);
      }
    }

    const displayHelp = () => {
      if(this.props.wizard_url) {
        return (
          <a target="_blank" className="btn btn-warning help" href={this.props.wizard_url}>
            Help
          </a>
        )
      }
    }

    const displayLogout = () => {
      if (this.props.page === Pages.REGISTER_PAGE) return
      if (this.props.page === Pages.ADDRESS_PAGE) return
      if (this.props.page === Pages.FIREBASE_DETAILS_PAGE) return

      return <Logout />
    }

    return (
      <div className="header">
        {logo()}
        <div className="button__container">
          {displayHelp()}
          {displayLogout()}
        </div>
      </div>
    )
  }
}

export default injectIntl(Header)
